<script setup>
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import CoinGlyph from '@/design/primitives/CoinGlyph.vue'
import { api, setToken } from '@/api/client.js'
import { EP } from '@/api/endpoints.js'

const route  = useRoute()
const router = useRouter()

onMounted(async () => {
  const token = route.query.token

  if (token) {
    /* Steam callback — server redirected with ?token=... */
    setToken(token)
    router.push('/profile')
    return
  }

  /* Fallback: check if already authenticated via cookie / header */
  try {
    const res = await api.get(EP.authUser)
    /* Server returns { user: null } not a 401 when unauthenticated */
    if (res.data?.user) {
      router.push('/profile')
    } else {
      router.push('/register')
    }
  } catch {
    router.push('/register')
  }
})
</script>

<template>
  <div class="callback">
    <div class="callback__content u-rise-in">
      <CoinGlyph :size="80" />
      <p class="callback__label u-display u-allcaps">ONE MOMENT…</p>
    </div>
  </div>
</template>

<style scoped>
.callback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.callback__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-6);
}

.callback__label {
  font-size: var(--fs-18);
  letter-spacing: 0.12em;
  color: var(--ink-soft);
  margin: 0;
}
</style>
